export const SPEECH_ENGINE_HANDOFF_MODE_OPTIONS = [
  { label: "Disabled", value: "disabled" },
  { label: "Context only", value: "contextOnly" },
  { label: "Continue from last message", value: "continueFromLastMessage" },
] as const;

export type SpeechEngineHandoffMode = (typeof SPEECH_ENGINE_HANDOFF_MODE_OPTIONS)[number]["value"];

export const DEFAULT_SPEECH_ENGINE_HANDOFF_MODE: SpeechEngineHandoffMode = "continueFromLastMessage";

export function resolveSpeechEngineHandoffMode(handoffMode?: SpeechEngineHandoffMode | null): SpeechEngineHandoffMode {
  if (handoffMode === "disabled" || handoffMode === "contextOnly" || handoffMode === "continueFromLastMessage") {
    return handoffMode;
  }

  return DEFAULT_SPEECH_ENGINE_HANDOFF_MODE;
}

export function isSpeechEngineHandoffActive(handoffMode: SpeechEngineHandoffMode) {
  return handoffMode !== "disabled";
}
